// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".preview-modal *[data-v-edf6b086]{margin:16px 0}", "",{"version":3,"sources":["webpack://./resources/assets/js/components/VJSModals/PreviewModal.vue"],"names":[],"mappings":"AAAA,kCAAA,aAAA","sourcesContent":[".preview-modal *{margin:16px 0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
